var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.09449 60.09449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.14633,
    y: 9.12139,
    width: 43.86898,
    height: 43.86898,
    rx: 10.01575,
    ry: 10.01575,
    transform: "translate(-13.14935 30.36641) rotate(-45)",
    strokeWidth: 0,
    fill: "#1d1d1b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.72245,
    y: 8.39389,
    width: 40.66394,
    height: 40.66394,
    rx: 10.01575,
    ry: 10.01575,
    transform: "translate(-11.50951 29.66529) rotate(-45)",
    strokeWidth: 0,
    fill: "#f59e00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.95969,13.62648c-1.80283-1.00157-3.20504-.80126-4.10646-.50079-1.20189.40063-2.00315,1.30205-2.50394,2.00315h0c-.30047.50079-.50079.80126-.60095,1.00157l-9.31465,15.92504h0v10.1159l8.81386-5.20819h0l9.31465-16.0252c.10016-.20032.30047-.50079.50079-.90142h0c.40063-.80126.7011-1.90299.50079-3.10488-.20032-.90142-.80126-2.30362-2.60409-3.3052h0ZM29.04567,34.45924l-4.7074-2.80441,9.31465-15.42425c.20032-.20032.90142-2.10331,3.40536-.7011,2.50394,1.30205,1.30205,3.3052,1.30205,3.3052l-9.11433,15.62457h-.20031Z",
    strokeWidth: 0,
    fill: "#82368c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUpIcon);
export default __webpack_public_path__ + "static/media/AddUpIcon.cc15a4a16ad0eabf9837dbc2e9974984.svg";
export { ForwardRef as ReactComponent };